/**
 * @typedef {Object} RouterProjectStates
 * @property {String} [activityFeed]
 * @property {String} tasks
 * @property {String} [timerLog]
 */

/**
 * @typedef {RouterProjectStates} RouterNavProjectStates
 * @property {String} projectsRoot
 * @property {String} projectsAssetProjectsList
 * @property {String} projectsManageAssets
 */

/** @type {RouterProjectStates} */
export const assetProjectStates = {
  activityFeed: 'app.assets.activity-feed',
  tasks: 'app.assets.tasks',
  timerLog: 'app.assets.timer-log',
};

/** @type {RouterNavProjectStates} */
export const projectStates = {
  activityFeed: 'app.projects.activity-feed',
  tasks: 'app.projects.tasks',
  timerLog: 'app.projects.timer-log',

  // Additional Navigation States
  projectsRoot: 'app.projects',
  projectsAssetProjectsList: 'app.projects.asset-projects-list',
  projectsManageAssets: 'app.projects.manage-assets',
};

/** @type {RouterProjectStates} */
export const projectTemplateStates = {
  tasks: 'app.projects.asset-tasks',
};



// WEBPACK FOOTER //
// ./src/js/projects/router-config.js